import { useNavigate } from 'react-router-dom'
import { NDT_SHORTCUTS, ShortcutTile, type NdtShortcut } from '@/components/ndt/ndtShortcuts'
import { useNdtQualifications } from '@/hooks/useNdtQualifications'
import { ndtFormPath, setNdtExitPath } from '@/utils/ndtNavigation'

const NDT_METHOD_SHORTCUTS = NDT_SHORTCUTS.filter((s) => s.group === 'ndt')

// NDT type selection page
const NDTSelection = () => {
  const navigate = useNavigate()
  const { loading, isQualified } = useNdtQualifications()
  const shortcuts = NDT_METHOD_SHORTCUTS.filter((s) => isQualified(s.name))

  const handleSelection = (shortcut: NdtShortcut) => {
    sessionStorage.setItem('inspectionType', 'ndt')
    sessionStorage.setItem('ndtType', shortcut.name)
    setNdtExitPath('/ndt-selection')

    navigate(ndtFormPath(shortcut.name) ?? '/company')
  }

  return (
    <div className="min-h-full p-4 sm:p-8" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {shortcuts.map((shortcut) => (
            <ShortcutTile key={shortcut.name} shortcut={shortcut} onSelect={handleSelection} size="lg" />
          ))}
        </div>

        {!loading && shortcuts.length === 0 && (
          <div className="text-center text-stone-500 text-lg sm:text-xl mt-8 sm:mt-12 px-4">
            Ingen NDT-kvalifikasjoner registrert
          </div>
        )}
      </div>
    </div>
  )
}

export default NDTSelection
